<template lang="html">
  <div class="cw-invite-users">
    <div class="card-image">
      <div class="hero is-small is-black">
        <div class="hero-body has-text-centered">
          <div class="title is-3">Password Reset</div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="hero is-small">
        <div class="hero-body has-text-centered">
          <h3 class="title is-5">Reset Account Password</h3>
          <p class="is-5">
            Enter the email addresses of the account associated with your
            account. You will recieve an email with a link to reset your
            password.
          </p>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input
            class="input is-underlined is-medium"
            type="text"
            placeholder="Email"
            v-model="email"
          />
        </div>
      </div>
      <div class="buttons is-padded-large has-text-centered">
        <a class="button is-black is-large is-rounded" @click="submit">
          <span>Send</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;

export default {
  name: 'cw-invite-users',
  // share common functionality with component mixins
  mixins: [],
  props: {},
  // variables
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState({
      token: state => state.user.token,
    }),
  },
  components: {},
  // methods
  watch: {},
  methods: {
    async submit() {
      this.$modal.show('wifi-loader', { message: 'Processing...' });

      try {
        let result = await axios.post(
          `${apiHost}/auth/request-password-reset`,
          {
            email: this.email,
          }
        );

        this.email = '';
        this.$modal.hide('wifi-loader');
        this.$modal.show('alert', result.data);

        this.$modal.hide('RequestPasswordReset');
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
  },
};
</script>

<style lang="stylus"></style>
